import { useUtility } from "@/composables/useUtility";
import { PersonNameInfo, PersonNameInfoClass } from "./PersonNameInfo";

const { SpecialCharacters, formatDateNY } = useUtility();

export interface DonationFullDTO {
  donationId: number;
  personId?: number | null;
  personName?: PersonNameInfo | null;
  amount: number;
  description?: string | null;
  fundId: number;
  fundName: string;
  initiativeId: number;
  initiativeName: string;
  restriction?: string | null;
  inMemoryOf?: string | null;
  inKind?: boolean | string | null;
  isMatch?: boolean | string | null; // Char → string
  skipAck?: boolean | string | null; // Char → string
  noAck?: boolean | string | null; // Char → string
  donationDate: Date | string; // LocalDate → ISO date string
  donationDateHR: string;
  purchaseDate: Date | string | null;
  purchaseDateHR: string | null;
  recurringDonationId?: number | null;
}

export class DonationFullDTOClass implements DonationFullDTO {
  donationId: number;
  personId?: number | null;
  personName?: PersonNameInfoClass | null;
  amount: number;
  description?: string | null;
  fundId: number;
  fundName: string;
  initiativeId: number;
  initiativeName: string;
  restriction?: string | null;
  inMemoryOf?: string | null;
  inKind?: boolean | string | null;
  isMatch?: boolean | string | null;
  skipAck?: boolean | string | null;
  noAck?: boolean | string | null;
  donationDate: Date;
  donationDateHR: string;
  recurringDonationId?: number | null;
  isRecurring: boolean;
  amountHR: string;
  personNameToUse: string;
  purchaseDate: Date | null;
  purchaseDateHR: string | null;

  constructor(data: Partial<DonationFullDTO> = {}) {
    this.donationId = data.donationId ?? 0;
    this.personId = data.personId ?? null;
    this.personName =
      data.personName && new PersonNameInfoClass(data.personName);
    this.amount = data.amount ?? 0;
    this.description = data.description ?? SpecialCharacters.DoublyHyphen;
    this.fundId = data.fundId ?? 0;
    this.fundName = data.fundName ?? SpecialCharacters.DoublyHyphen;
    this.initiativeId = data.initiativeId ?? 0;
    this.initiativeName = data.initiativeName ?? "Unknown";
    this.restriction = data.restriction ?? SpecialCharacters.DoublyHyphen;
    this.inMemoryOf = data.inMemoryOf ?? SpecialCharacters.DoublyHyphen;
    this.inKind = data.inKind == "Y";
    this.isMatch = data.isMatch == "Y";
    this.skipAck = data.skipAck == "Y";
    this.noAck = data.noAck == "Y";
    this.donationDate = data.donationDate
      ? new Date(data.donationDate)
      : new Date();
    this.purchaseDate = data.purchaseDate ? new Date(data.purchaseDate) : null;
    this.purchaseDateHR =
      formatDateNY(data.purchaseDate) ?? SpecialCharacters.DoublyHyphen;
    this.donationDateHR =
      formatDateNY(data.donationDate) ?? SpecialCharacters.DoublyHyphen;
    this.recurringDonationId = data.recurringDonationId ?? null;
    this.isRecurring = !!data.recurringDonationId;
    this.amountHR = data.amount
      ? "$" + data.amount
      : SpecialCharacters.DoublyHyphen;
    this.personNameToUse =
      this.personId && this.personName
        ? this.personName.getFullName()
        : SpecialCharacters.DoublyHyphen;
  }
}
